import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';

export const getPriorityData = async () => {
    try {
        const response = await ApiClient.get(`/homePage/aboutPage/getbocCount`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}



export const updateCouncilPriority = async ({ id, order }) => {
    try {
        const response = await ApiClient.put(`/homePage/aboutPage/updateBOCOrder/${id}`, 
            { order }, 
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        console.log("Priority update response:", response);
        return response;
    } catch (error) {
        throw error;
    }
};